import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  httpClient = inject(HttpClient);
  currentRestaurantSettings$ = new BehaviorSubject<any>(null);

  constructor() {}

  getSettings(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/restaurants/settings').pipe(
      catchError((error) => {
        console.error('Error fetching settings:', error);
        return of(error);
      }),
    );
  }

  editSettings(settings: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/restaurants/settings/order/toggle', settings)
      .pipe(
        catchError((error) => {
          console.error('Error editing settings:', error);
          return of(error);
        }),
      );
  }

  /** KDS and other `feature` row flags — one `setting_key` per call, restaurant admin only. */
  toggleFeatureSetting(settings: { setting_key: string; value: boolean }): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/restaurants/settings/feature/toggle', settings)
      .pipe(
        catchError((error) => {
          console.error('Error toggling feature setting:', error);
          return of(error);
        }),
      );
  }

  changePaymentSettings(settings: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/restaurants/settings/payment/toggle', settings)
      .pipe(
        catchError((error) => {
          console.error('Error changing payment settings:', error);
          return of(error);
        }),
      );
  }
}
